import { Record } from 'immutable';
import { FILTER_MISALIGNMENT } from '../constants/overlayTypes';
const FilterMisalignmentOverlay = Record({
  previous: null,
  deepLinkedThreadMissing: false,
  type: FILTER_MISALIGNMENT
}, 'FilterMisalignmentOverlay');
export default FilterMisalignmentOverlay;